<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="drivers"
      class="elevation-1"
      :loading="loading"
      :items-per-page="-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Řidiči</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer><v-dialog
          v-model="dialog"
          max-width="650"
        >
          <template
            v-slot:activator="{ on, attrs }"
          >
            <v-btn
              @click="editedItem = defaultItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              Přidat řidiče
            </v-btn>
          </template>
          <DriverForm
            :item="editedItem"
            :city-districts="cityDistricts"
            @data-saved="getDrivers"
            v-if="dialog"
          ></DriverForm>
        </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editDriver(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="toggleActive(item)"
        >
          {{item.active ? 'mdi-sleep' : 'mdi-sleep-off'}}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getDrivers">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DriverForm from '../../forms/admin/DriverForm'
export default {
  name: 'Drivers',
  components: { DriverForm },
  data () {
    return {
      loading: true,
      dialog: false,
      editedItem: {},
      defaultItem: {
        id: null,
        email: '',
        firstName: '',
        active: false
      },
      headers: [
        { text: 'Název', value: 'firstName' },
        { text: 'Login', value: 'email' },
        { text: 'Městké části', value: 'districtsStr' },
        { text: 'Akce', value: 'actions' }
      ],
      drivers: [],
      cityDistricts: []
    }
  },
  methods: {
    initialize () {
      this.$http.get('/admin/city-districts')
        .then(response => {
          this.cityDistricts = this.keysToCamelCase(response.data)
            .filter(district => district.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.getDrivers()
    },
    getDrivers () {
      this.loading = true
      this.dialog = false
      this.$http.get('/admin/roles/4')
        .then(response => {
          this.drivers = this.keysToCamelCase(response.data)
            .map(driver => {
              driver.districtsStr = driver.districts
                .map(district => district.name)
                .join(', ')
              return driver
            })
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    editDriver (driver) {
      this.editedItem = Object.assign({}, driver)
      this.dialog = true
    },
    toggleActive (driver) {
      driver.active = !driver.active
      this.$http.patch(`/admin/users/${driver.id}`, this.keysToSnakeCase(driver))
        .then(response => {
          this.getDrivers()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>

</style>
